import React, { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import clsx from 'clsx';
// import  JsonEditorWrapper  from "../../../common/JsonEditorWrapper";
import ReactJSONEditor from "react-jsoneditor-wrapper";
import { useTranslation } from "react-i18next";


export const ViewDetails = (props: any) => {

    const { modelRef } = props;
    const dispatch = useAppDispatch();
    const [tab, setTab] = useState('Description');
    const { t } = useTranslation();

    const { ResponseBody, RequestURI, ActionDescription } = useAppSelector((state) => state.webHookReceiverLog);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const JsonParseCheck = () => {
        let parsedJson;
        let isJsonValid = false;

        try {
            parsedJson = JSON.parse(ActionDescription);
            isJsonValid = true;
        } catch (error) {
            //   console.log('Invalid JSON:', error);
        }

        return isJsonValid;
    };
    const handleCloseOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    return (
        <>
            <div className='card-body'>
                <div className='row' >

                    <div className='card card-custom'>
                        <div className='card-header card-header-stretch overflow-auto'>
                            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Description' })}
                                        onClick={() => setTab('Description')}
                                        role='tab'
                                    >
                                        Description
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Request JSON' })}
                                        onClick={() => setTab('Request JSON')}
                                        role='tab'
                                    >
                                        Request JSON
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <form className='form'>
                            <div className='card-body'>
                                <div className='tab-content pt-0'>
                                    <div className={clsx('tab-pane', { active: tab === 'Description' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label className="form-label">{`Request URI : `}</label>
                                                <span>{RequestURI}</span>

                                            </div>
                                        </div>
                                        <div className='row' style={{ marginTop: '10px' }}>
                                            <div className="col-md-12">
                                                <label className="form-label">{`Details : `}</label>
                                                <span>{ActionDescription}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={clsx('tab-pane', { active: tab === 'Request JSON' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <ReactJSONEditor json={ResponseBody} name="RequestBody" mode="view" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                        </button>
                        <button
                            className="btn btn-light btn-sm me-2"
                            type='button'
                            //id="kt_OffCanvas"

                            data-kt-element='send'
                            onClick={handleCloseOnClickEvent}
                        //onClick={handleResetFiltersOnClickEvent}
                        >
                     {t('Cancel')}

                        </button>
                    </div>
                </div>
            </div>

        </>
    )

}



{/* <div className="modal fade" tabIndex={-1} id="viewDetailModal">
<div className="modal-dialog">
    <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title">Details</h5>
            <div
                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                data-bs-dismiss="modal"
                aria-label="Close"
            >
                <KTSVG
                    path="/media/icons/duotune/arrows/arr061.svg"
                    className="svg-icon svg-icon-2x"
                />
            </div>
        </div> 
    <div className='card card-custom'>
        <div className='card-header card-header-stretch overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                <li className='nav-item'>
                    <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Description' })}
                        onClick={() => setTab('Description')}
                        role='tab'
                    >
                        Description
                    </a>
                </li>
                <li className='nav-item'>
                    <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Request JSON' })}
                        onClick={() => setTab('Request JSON')}
                        role='tab'
                    >
                        Request JSON
                    </a>
                </li>
            </ul>
        </div>
        <form className='form'>
            <div className='card-body'>
                <div className='tab-content pt-0'>
                    <div className={clsx('tab-pane', { active: tab === 'Description' })}>
                        <div className='row'>
                            <div className="col-md-12">
                                <label className="form-label">{`Request URI : `}</label>
                                <span>{RequestURI}</span>
                                
                            </div>
                        </div>
                        <div className='row' style={{marginTop:'10px'}}>
                            <div className="col-md-12">
                                <label className="form-label">{`Details : `}</label>
                                <span>{ActionDescription}</span>
                            </div>
                        </div>
                    </div>

                    <div className={clsx('tab-pane', { active: tab === 'Request JSON' })}>
                        <div className='row'>
                            <div className="col-md-12">
                                <ReactJSONEditor json={ResponseBody} name="RequestBody" mode="view"    />  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-light btn-sm"
                data-bs-dismiss="modal"
            >
                Close
            </button>
        </div>
    </div>
</div>
</div>  */}